<template lang="pug">
div
	v-e24-nav-bar
	section.maincolumn-constrained
		form.login-form(name='form', novalidate v-on:submit.prevent="")
			.login-body
				h3 {{ $t('login.recoverPassTitle') }}
				span {{ $t('login.recoverText') }}
				br
				.alert.alert-warning(v-if='authReason') {{authReason}}
				.alert.alert-danger(v-if='authError') {{authError}}

				.login-lbl
					label {{ $t('label.userEmail') }}
					input.login-field(name='login', v-model='searchToRecover', required, autofocus, novalidate='')

				.btn-login-cnt
					b-button(variant="success", size="lg", @click='recover') {{ $t('label.ok') }}
	v-e24-footer(:build="build")

	md-snackbar(md-position='center', :md-duration='snackbar.duration', :md-active.sync='snackbar.show', md-persistent='')
		span {{ $t(snackbar.message) }}
		md-button.md-primary(@click='snackbar.show = false') {{ $t('label.ok') }}
</template>

<script>
import Vue from 'vue'
import { mapActions } from 'vuex'
import _ from 'lodash'
import readBuild from '../../util/readBuild'

export default {
	name: 'ForgotPassword',
	data () {
		return {
			build: '',
			authError: '',
			authReason: '',
			searchToRecover: '',
			snackbar: { show: false, message: '', duration: 1000 }
		}
	},
	mixins: [readBuild],
	mounted () {
		this.build = this.getBuild()
	},
	methods: {
		...mapActions(['infoDialog']),

		recover () {
			var recoverEmail = ''

			if (this.searchToRecover !== '') {
				// Search
				Vue.jnx.userService.findOneByUsernameOrEmail(this.searchToRecover).then((userFound) => {
					console.log('user found', userFound)
					// Get Email in order to create invitation
					if (!_.isNil(userFound)) {
						console.log('findUserByUserName', userFound)
						const emails = userFound.contact.emailAddresses(false)
						if (!_.isNil(emails) && emails.length > 0) {
							// console.log('user found emails', emails)
							_.every(emails, (email) => {
								// TODO: Validate if it is a real email address
								if (email.address !== '') {
									// Register recovery
									recoverEmail = email.address
									Vue.jnx.userActionService.recoverPassword(userFound.userId, userFound.contact.id, recoverEmail).then((resp) => {
										// this.authReason = this.$t('user.dialogs.recoveryDataSent')
										this.snackbar.message = 'user.dialogs.recoveryDataSent'
										this.snackbar.show = true
										setTimeout(() => {
											this.$router.push({name: 'connect', params: { goodbye: '', redirect: '' }})
										}, 3000)
										console.log('Password recovery started', resp)
									})
									return false
								}
							})
						} else {
							this.infoDialog(this.$t('login.dialogs.recoverEmailNotFound'))
						}
					} else {
						this.infoDialog(this.$t('login.dialogs.usernameNotFound'))
					}
				})
			} else {
				this.infoDialog(this.$t(''))
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/app/login/forgot-password.vue